module.exports = __webpack_public_path__ + "assets/img/LTC016.d47b5ed7.png";